import { render, staticRenderFns } from "./NotificationDisplayPage.vue?vue&type=template&id=2be613b6&scoped=true"
import script from "./NotificationDisplayPage.vue?vue&type=script&lang=js"
export * from "./NotificationDisplayPage.vue?vue&type=script&lang=js"
import style0 from "./NotificationDisplayPage.vue?vue&type=style&index=0&id=2be613b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be613b6",
  null
  
)

export default component.exports